/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

export class BaseCreator  {

       protected toUpperCase(value:string):string {
              if ( !value ) return '';
              return value.toString().trim().toUpperCase();
       }
}
